// src/components/layout/DashboardLayout.jsx
// Responsive: sidebar hidden on mobile, bottom nav shown instead
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUIStore } from '../../store/uiStore';
import { useAuth }   from '../../hooks/useAuth';
import Sidebar       from './Sidebar';
import { C }         from '../../styles/tokens';

// ── Mobile bottom nav ──────────────────────────
const TALENT_BOTTOM_NAV = [
  { icon: '⊞', label: 'Home',     path: '/dashboard' },
  { icon: '🌐', label: 'Jobs',     path: '/opportunities' },
  { icon: '🪙', label: 'Wallet',   path: '/wallet' },
  { icon: '🎓', label: 'Training', path: '/training' },
  { icon: '👤', label: 'Profile',  path: '/profile' },
];

const COLLAB_BOTTOM_NAV = [
  { icon: '⊞', label: 'Home',     path: '/dashboard' },
  { icon: '🏢', label: 'Portal',   path: '/collaborators' },
  { icon: '🌐', label: 'Jobs',     path: '/opportunities' },
  { icon: '🪙', label: 'Wallet',   path: '/wallet' },
  { icon: '👤', label: 'Profile',  path: '/profile' },
];

function MobileBottomNav() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { profile } = useAuth();
  const isActive  = (path) => location.pathname === path;
  const BOTTOM_NAV = profile?.role === 'collaborator' ? COLLAB_BOTTOM_NAV : TALENT_BOTTOM_NAV;

  return (
    <div style={{
      display: 'none',
      position: 'fixed', bottom: 0, left: 0, right: 0,
      height: '60px',
      background: '#0a0a1a',
      borderTop: '1px solid rgba(254,52,232,0.12)',
      zIndex: 90,
      alignItems: 'center',
      justifyContent: 'space-around',
      paddingBottom: 'env(safe-area-inset-bottom)',
    }}
    className="mobile-bottom-nav-inner"
    >
      <style>{`
        @media (max-width: 768px) {
          .mobile-bottom-nav-inner { display: flex !important; }
          .dashboard-content { padding-bottom: 72px !important; }
        }
      `}</style>
      {BOTTOM_NAV.map(item => (
        <button
          key={item.path}
          onClick={() => navigate(item.path)}
          style={{
            flex: 1, height: '100%', border: 'none', background: 'transparent',
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            gap: '3px', cursor: 'pointer', position: 'relative',
            color: isActive(item.path) ? C.magenta : 'rgba(255,255,255,0.4)',
            transition: 'color 0.2s',
          }}
        >
          {isActive(item.path) && (
            <div style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: '24px', height: '2px', background: C.magenta, borderRadius: '0 0 2px 2px' }} />
          )}
          <span style={{ fontSize: '18px', lineHeight: 1 }}>{item.icon}</span>
          <span style={{ fontSize: '10px', fontWeight: isActive(item.path) ? 700 : 500 }}>{item.label}</span>
        </button>
      ))}
    </div>
  );
}

export default function DashboardLayout({ children, title, subtitle }) {
  const { sidebarCollapsed } = useUIStore();
  const sw = sidebarCollapsed ? 68 : 240;

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: C.bg, paddingTop: '64px' }}>
      <style>{`
        @media (max-width: 768px) {
          .sidebar-desktop   { display: none !important; }
          .dashboard-main    { margin-left: 0 !important; }
        }
      `}</style>

      {/* Sidebar — hidden on mobile */}
      <div className="sidebar-desktop">
        <Sidebar />
      </div>

      {/* Main content */}
      <div
        className="dashboard-main"
        style={{ flex: 1, marginLeft: sw, transition: 'margin-left 0.3s cubic-bezier(0.16,1,0.3,1)', minWidth: 0, display: 'flex', flexDirection: 'column' }}
      >
        {title && (
          <div style={{ padding: 'clamp(16px,3vw,24px) clamp(16px,3vw,28px) 0' }}>
            <h1 style={{ fontFamily: "'Syne',sans-serif", fontSize: 'clamp(18px,3vw,22px)', fontWeight: 800 }}>{title}</h1>
            {subtitle && <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.38)', marginTop: '3px' }}>{subtitle}</p>}
          </div>
        )}
        <main
          className="dashboard-content"
          style={{ flex: 1, padding: 'clamp(14px,3vw,20px) clamp(14px,3vw,28px) 40px' }}
        >
          {children}
        </main>
      </div>

      {/* Mobile bottom nav */}
      <MobileBottomNav />
    </div>
  );
}
